import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Blog() {
  const blogPosts = [
    {
      id: 1,
      title: "Top 10 Blockchain Development Companies in 2025",
      description:
        "Blog Blockchain Coin & Token Crypto Exchange Defi DEXs Artificial Intelligence Android Development Home 1.",
      image: "assets/images/about/career.jpg",
    },
    {
      id: 2,
      title: "Top 10 Blockchain Development Companies in 2025",
      description:
        "Blog Blockchain Coin & Token Crypto Exchange Defi DEXs Artificial Intelligence Android Development Home 1.",
      image: "assets/images/about/career.jpg",
    },

    {
      id: 3,
      title: "Top 10 Blockchain Development Companies in 2025",
      description:
        "Blog Blockchain Coin & Token Crypto Exchange Defi DEXs Artificial Intelligence Android Development Home 1.",
      image: "assets/images/about/career.jpg",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Blockchain & AI Insights | Blockcryp Blog</title>
        <meta
          name="description"
          content="Stay updated with the latest in blockchain, Web3, and AI. Explore expert insights, industry trends, and development tips from Blockcryp’s tech blog."
        />
        <meta
          name="keywords"
          content="blockchain blog, AI development blog, Web3 industry insights, smart contract tutorials, DeFi trends 2025, NFT development tips, crypto exchange updates, blockchain development news, AI use cases in business, emerging tech blog"
        />
      </Helmet>
      {/* ---------------- hero blog section start ---------- */}

      <section className="hero position-relative space100">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="mb-3 fw-bold text-light">Our Latest Blog</h2>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/home">Home</a>
                  </li>
                  <li className="breadcrumb active text-light" aria-current="page">
                    / Blog
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>
      {/* ---------------- hero blog section end  ---------- */}

      {/* --------- blog section start ---- */}
      <div className="blog_section space80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-9">
              <div className="row">
                {blogPosts.map((post, index) => (
                  <div className="col-lg-4 col-md-6 mb-4" key={post.id}>
                    <Link to="/blogdetails">
                      <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.3 * index }}
                        viewport={{ once: false, amount: 0.5 }}
                        className="blog_box"
                      >
                        <img
                          src={post.image}
                          alt="blog image"
                          className="w-100 border_md"
                        />
                        <div className="blog_content py-3">
                          <h4 className="text_20 fw-semibold mb-3 lh-base">
                            {post.title}
                          </h4>
                          <p className="mb-0 text-secondary text_14">
                            {post.description}
                          </p>
                          <button
                            className="button theme_btn mt-3 text_14"
                            type="button"
                          >
                            Read More
                          </button>
                        </div>
                      </motion.div>
                    </Link>
                  </div>
                ))}

                <nav aria-label="Page navigation example ">
                  <ul className="pagination justify-content-center py-4">
                    <li className="page-item"><Link className="page-link" to="#">Previous</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">1</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">Next</Link></li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-4 col-xl-3">
              <div className="bloglist_main">
                {/* <div> */}
                <h6 className="p-3 text-center mb-0 fw-bold">
                  Categories
                </h6>
                {/* </div> */}
                <ul className="blog_list d-flex flex-column">
                  <li className="d-flex flex-wrap position-relative py-2">
                    <Link to="#" className="me-auto ms-4 fw-bold">
                      services
                    </Link>
                  </li>
                  <li className="d-flex flex-wrap position-relative py-2">
                    <Link to="#" className="me-auto ms-4 fw-bold">
                      services
                    </Link>
                  </li>
                  <li className="d-flex flex-wrap position-relative py-2">
                    <Link to="#" className="me-auto ms-4 fw-bold">
                      services
                    </Link>
                  </li>
                  <li className="d-flex flex-wrap position-relative py-2">
                    <Link to="#" className="me-auto ms-4 fw-bold">
                      services
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* --------- blog section start ---- */}
    </>
  );
}
